// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/b891113e4cd3df1001bd.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"6a11d47c76d54f97b2f7","266":"6619e34e42d15ecb9b63","267":"c5a480cb873b118a78a2"}[chunkId] + ".chunk.js";
};